import React from 'react'

import { Card } from './Card/Card'
import style from './CardsList.module.css'

import { useAppSelector } from 'common/hooks'
import { selectCategories } from 'features/dashboard'

type PropsType = {}

export const CardsList = ({}: PropsType) => {
  const categories = useAppSelector(selectCategories)

  return (
    <ul className={style.list}>
      {categories.map(category => (
        <Card key={category.id} category={category} />
      ))}
    </ul>
  )
}
